(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.amp-warranty .tab-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      var id = btn.getAttribute('data-tab');
      var root = btn.closest('.amp-warranty');
      root.querySelectorAll('.panel').forEach(function(p){ p.classList.remove('active'); });
      root.querySelectorAll('.tab-btn').forEach(function(b){ b.classList.remove('active'); });
      root.querySelector('#panel-' + id).classList.add('active');
      btn.classList.add('active');
      var top = root.querySelector('.tabs').getBoundingClientRect().top + window.pageYOffset - 30;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  });
  function ampPicked(input, target){
    var names = Array.prototype.map.call(input.files, function(f){ return f.name; }).join(', ');
    document.getElementById(target).textContent = names || '';
  }

document.querySelectorAll('.amp-warranty #claim-form input[type="file"]').forEach(function(input){
  input.required = false;
  input.disabled = true;
  var field = input.closest('.field');
  if(field) field.style.display = 'none';
});
document.querySelectorAll('.amp-warranty #claim-form .section-title').forEach(function(title){
  if(title.textContent.trim().toLowerCase() === 'photos') title.style.display = 'none';
});

  document.querySelectorAll('.amp-warranty f.no-jsorm').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!form.checkValidity()){ form.reportValidity(); return; }
      var btn = form.querySelector('.btn'); if(btn) btn.style.display='none';
      var ok = form.querySelector('.success'); if(ok) ok.style.display='block';
    });
  });

  document.querySelectorAll('.amp-warranty form').forEach(function(form){
      form.addEventListener('submit',function(e){
                  e.preventDefault();
                  if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}
                form.action='/contact#contact_form';
                    form.method='post';
                        form.removeAttribute('enctype');
                            var email=form.querySelector('input[type="email"]');
                                if(email){email.name='contact[email]';}
                                    var body=[];
                                        form.querySelectorAll('input,select,textarea').forEach(function(el){
                                                if(el.type=='hidden'||el.type=='submit'||el.type=='file'){return;}
                                                      if((el.type=='checkbox'||el.type=='radio')&&!el.checked){return;}
                                                            var label=form.querySelector('label[for="'+el.id+'"]');
                                                                  body.push((label?label.textContent.trim():el.id)+': '+(el.value||''));
                                        });
                                            function hidden(name,value){
                                                    var el=form.querySelector('[name="'+name+'"]');
                                                          if(!el){el=document.createElement('input');el.type='hidden';el.name=name;form.appendChild(el);}
                                                                el.value=value;
                                            }
                                                hidden('form_type','contact');
                                                    hidden('utf8','\u2713');
                                                        hidden('contact[body]',body.join('\n'));
                                                        fetch(form.action,{method:'POST',body:new FormData(form)}).then(function(){
                                                          var btn=form.querySelector('.btn');if(btn){btn.style.display='none';}
                                                          var ok=form.querySelector('.success');if(ok){ok.style.display='block';}
                                                          if(form.id==='claim-form'){setTimeout(function(){window.location.href='/products/processing-fee';},900);}
                                                        });
                                          });
                                        });
                                        

  } catch(e) { console.error(e); }
})();
})();
